module.exports = __webpack_public_path__ + "img/IMG_2235-scaled.751c5cb1.jpg";